import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Input } from '@angular/core';
import { IPlanSummaryLecturer, IPlanSummaryResident, IPlanSummaryRotation } from '../../../models/PlanSummary';
import { AppService } from '../../../services/app.service';

@Component({
    selector: 'app-plan-summary-courses-grade',
    templateUrl: './plan-summary-courses-grade.component.html',
    styleUrls: ['../plan-summary.component.scss']
})
export class PlanSummaryCoursesGradeComponent {
    constructor(
        private app: AppService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set data(value: { resident: IPlanSummaryResident, rotation: IPlanSummaryRotation }) {
        this.resident = value.resident;
        this.rotation = value.rotation;
        this.lecturer = value.rotation.Lecturers[0];
    }

    resident: IPlanSummaryResident;
    rotation: IPlanSummaryRotation;
    lecturer: IPlanSummaryLecturer;

    get url(): string {
        const para = {
            Kind: 'Final',
            StudentId: this.resident?.StudentId,
            SubjectId: this.rotation?.SubjectId,
            StudyYear: this.rotation?.StudyYear,
            SubjectSemesterNr: this.rotation?.SemesterNumber,
            LecturerId: this.lecturer?.Id
        };

        const query = Object.keys(para).map(t => `${t}=${encodeURIComponent(para[t])}`).join('&');

        return `${location.origin}/${this.app.currentLanguage}/add-grades?${query}`;
    }

    close() {
        this.activeModal.dismiss();
    }
}
